import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { SalaryComponentsService } from '../../services/salary-components.service'
import * as scActions from './salary-components.actions'
import { catchError, exhaustMap, map, of, switchMap } from 'rxjs'
import { SalaryComponent } from './salary-components.state'

export const loadSalaryComponents$ = createEffect(
  (actions$ = inject(Actions), scService = inject(SalaryComponentsService)) =>
    actions$.pipe(
      ofType(scActions.loadSalaryComponents),
      switchMap(({ componentType, belongsTo }) =>
        scService.loadSalaryComponents(componentType, belongsTo).pipe(
          map((salaryComponents: SalaryComponent[]) =>
            scActions.loadSalaryComponentsSuccess({ componentType, salaryComponents })
          ),
          catchError(error => of(scActions.loadSalaryComponentsFailure({ error: error.message })))
        )
      )
    ),
  { functional: true }
)

// Add item effect
export const addSalaryComponent$ = createEffect(
  (actions$ = inject(Actions), scService = inject(SalaryComponentsService)) =>
    actions$.pipe(
      ofType(scActions.addSalaryComponent),
      exhaustMap(({ salaryComponent }) =>
        scService.addSalaryComponent(salaryComponent).pipe(
          map((savedSalaryComponent: SalaryComponent) =>
            scActions.addSalaryComponentSuccess({ salaryComponent: savedSalaryComponent })
          ),
          catchError(error => of(scActions.addSalaryComponentFailure({ error: error.message })))
        )
      )
    ),
  { functional: true }
)

// Edit item effect
export const editSalaryComponent$ = createEffect(
  (actions$ = inject(Actions), scService = inject(SalaryComponentsService)) =>
    actions$.pipe(
      ofType(scActions.editSalaryComponent),
      exhaustMap(({ id, salaryComponent }) =>
        scService.updateSalaryComponent(id, salaryComponent).pipe(
          map((savedSalaryComponent: SalaryComponent) =>
            scActions.editSalaryComponentSuccess({ salaryComponent: savedSalaryComponent })
          ),
          catchError(error => of(scActions.addSalaryComponentFailure({ error: error.message })))
        )
      )
    ),
  { functional: true }
)

// Edit item effect
export const deleteSalaryComponent$ = createEffect(
  (actions$ = inject(Actions), scService = inject(SalaryComponentsService)) =>
    actions$.pipe(
      ofType(scActions.deleteSalaryComponent),
      exhaustMap(({ id, componentType }) =>
        scService.deleteSalaryComponent(id).pipe(
          map(({ status }) =>
            status === 'success'
              ? scActions.deleteSalaryComponentSuccess({ id, componentType })
              : scActions.deleteSalaryComponentFailure({ error: status })
          ),
          catchError(error => of(scActions.addSalaryComponentFailure({ error: error.message })))
        )
      )
    ),
  { functional: true }
)

export const salaryComponentsEffects = {
  loadSalaryComponents$,
  addSalaryComponent$,
  editSalaryComponent$,
  deleteSalaryComponent$
}
